"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreChangeDescription = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const ChangeDescription = styled_components_1.default.div.withConfig({ displayName: "reports-ChangeDescription", componentId: "reports-v9kan2" }) `
  border-radius: 24px;
  background-color: ${({ sign, theme }) => !sign ? theme.neutral100 : sign > 0 ? theme.seaturtleGreen100 : theme.sebastianRed100};
  padding: 8px 16px;
  display: flex;
  text-align: center;
  max-width: max-content;
  align-items: center;

  & > ${base_react_components_1.Copy} {
    padding-right: 8px;
  }
`;
const Arrow = styled_components_1.default.div.withConfig({ displayName: "reports-Arrow", componentId: "reports-q6cbjq" }) `
  width: 0;
  height: 0;

  ${({ isPositive, theme }) => isPositive
    ? `border-bottom: 8px solid ${theme.seaturtleGreen200};`
    : `border-top: 8px solid ${theme.sebastianRed200};`}

  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
`;
/** The ScoreChangeDescription summarizes the change in score between this report and the last */
const ScoreChangeDescription = ({ points = 0 }) => {
    const sign = Math.sign(points);
    const numPoints = Math.abs(points);
    const isPositive = sign > 0;
    return (react_1.default.createElement(ChangeDescription, { sign: sign, "data-testid": "ScoreChangeDescription:Wrapper" }, sign ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(base_react_components_1.Copy, { size: "sm", "data-testid": `ScoreChangeDescription:${isPositive ? 'Positive' : 'Negative'}-Change` },
            "Your score ",
            isPositive ? 'increased by' : 'decreased by',
            " ",
            numPoints,
            " points"),
        react_1.default.createElement(Arrow, { isPositive: isPositive, "data-testid": `ScoreChangeDescription:Arrow-${isPositive ? 'Up' : 'Down'}` }))) : (react_1.default.createElement(base_react_components_1.Copy, { size: "sm", "data-testid": "ScoreChangeDescription:No-Change" }, "Your score did not change"))));
};
exports.ScoreChangeDescription = ScoreChangeDescription;
exports.default = exports.ScoreChangeDescription;
//# sourceMappingURL=index.js.map